import MealList from "./MealList";

export default MealList;